var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.943 5.171a.457.457 0 01.457.458v5.485a.457.457 0 01-.914 0V5.63a.457.457 0 01.457-.458zm2.285 0a.457.457 0 01.458.458v5.485a.457.457 0 01-.915 0V5.63a.457.457 0 01.457-.458zm2.743.458a.457.457 0 10-.914 0v5.485a.457.457 0 00.914 0V5.63z",
    fill: "#0A111E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.171 2.886a.915.915 0 01-.914.914H10.8v8.229a1.829 1.829 0 01-1.829 1.828H3.486a1.829 1.829 0 01-1.829-1.828V3.8H1.2a.914.914 0 01-.914-.914V1.97a.914.914 0 01.914-.914h3.2a.914.914 0 01.914-.914h1.829a.914.914 0 01.914.914h3.2a.914.914 0 01.914.914v.915zM2.68 3.8l-.108.054v8.175a.914.914 0 00.915.914H8.97a.915.915 0 00.915-.914V3.854L9.778 3.8H2.679zM1.2 2.886V1.97h10.058v.915H1.2z",
    fill: "#0A111E"
  })));
}
export default SvgTrashIcon;